import React from 'react';
import { ToggleButton, ToggleButtonGroup, Tooltip } from '@mui/material';

/**
 * Calendar (Jan–Dec) vs Financial (Apr–Mar) year grouping. Financial years are
 * labelled e.g. "2024/25" and re-index months/quarters to start in April.
 */
export default function YearBasisToggle({ value, onChange }) {
  return (
    <ToggleButtonGroup size="small" exclusive value={value} onChange={(_, v) => v && onChange(v)}>
      <ToggleButton value="calendar">Calendar yr</ToggleButton>
      <Tooltip title="Financial year: 1 Apr – 31 Mar (labelled e.g. 2024/25)" arrow>
        <ToggleButton value="fiscal">Financial yr</ToggleButton>
      </Tooltip>
    </ToggleButtonGroup>
  );
}
